import { render, staticRenderFns } from "./project-task-panel.vue?vue&type=template&id=4dff1ae5&scoped=true"
import script from "./project-task-panel.vue?vue&type=script&lang=js"
export * from "./project-task-panel.vue?vue&type=script&lang=js"
import style0 from "./project-task-panel.vue?vue&type=style&index=0&id=4dff1ae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff1ae5",
  null
  
)

export default component.exports